import { apiRequest } from "./client";

function queryString(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const value = search.toString();
  return value ? `?${value}` : "";
}

export const ordersApi = {
  list(projectId, params = {}) {
    return apiRequest(`/projects/${projectId}/orders${queryString(params)}`);
  },

  get(projectId, orderId) {
    return apiRequest(`/projects/${projectId}/orders/${orderId}`);
  },

  updateStatus(projectId, orderId, status) {
    return apiRequest(`/projects/${projectId}/orders/${orderId}/status`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    });
  },
};
